export default __webpack_public_path__ + "static/media/Testimonials.1a449c1e.png";